function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}


function updateFreeShippingMessage(cartTotalPrice) {
  const threshold = 65;
  const progressEl = document.querySelector('.progress-bar__progress');
  const messageRegular = document.querySelector('.progress-message');
  const messageSuccess = document.querySelector('.progress-message--success');
  const amountUntilFreeShipping = document.getElementById('amountFreeShipping');

  if(!progressEl || !messageRegular || !messageSuccess || !amountUntilFreeShipping) return;
  amountUntilFreeShipping.innerHTML = threshold - cartTotalPrice;
  let progress = (cartTotalPrice / threshold).toFixed(2) * 100 - 20;
  if(cartTotalPrice == 0) progress = 5;
  else if(progress < 10) progress = 10;
 
  if(threshold - cartTotalPrice <= 0) {
    messageRegular.classList.add('hidden');
    messageSuccess.classList.remove('hidden');
    progressEl.style.width = '100%';
  }
  else {
    messageRegular.classList.remove('hidden');
    messageSuccess.classList.add('hidden');
    progressEl.style.width = String(progress) + '%';
  }
}

function updatePopUpMessage(totalPrice){
  const threshold = 65;
  const popupContainer = document.getElementById('add-to-cart-popup');
  const priceEl = document.getElementById("price-left");
  const freeShippingMessage = popupContainer.querySelector(".free-shipping-text");
  const mainText = popupContainer.querySelector(".main-text");

  if(!popupContainer || !priceEl || !freeShippingMessage) return;
  popupContainer.classList.toggle("cart-0", !totalPrice );
  
  // popupContainer.classList.toggle("hidden", totalPrice <= 0);
  if( totalPrice > 0) {
    setTimeout(() => {
      popupContainer.classList.add("animate");

    },10);
  }
  if( totalPrice == 0 ) {
    popupContainer.classList.remove("animate");
    setTimeout(() => {
      popupContainer.classList.toggle("hidden", totalPrice <= 0)
    },10);
  }


  const priceLeft = threshold - totalPrice;
  if(priceLeft > 0) {
    priceEl.innerHTML = formatMoney(priceLeft);
    mainText.style.display = '';
    freeShippingMessage.style.display = 'none';
  }else{
    priceEl.innerHTML = 0;
    freeShippingMessage.style.display = '';
    mainText.style.display = 'none';
  }
}

function formatMoney(amount) {
  let roundedAmount = Math.round(amount * 100) / 100;
  
  if (Number.isInteger(roundedAmount)) {
      return `$${roundedAmount.toLocaleString()}`;
  } else {
      return `$${roundedAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
}

/* ================================
   Protein price update helpers
   ================================ */

function formatMoneyFromCents(cents) {
  const n = Number(cents || 0);
  return `$${(n / 100).toFixed(2)}`;
}

function getCollectionDiscountCode() {
  const params = new URLSearchParams(window.location.search);
  const urlDiscountCode = (params.get('discount') || '').trim();
  if (urlDiscountCode) return urlDiscountCode.toUpperCase();

  const cookieDiscountCode = getCookie('discount_code');
  return cookieDiscountCode ? cookieDiscountCode.trim().toUpperCase() : '';
}

function getCollectionDiscountConfig() {
  const discountCode = getCollectionDiscountCode();
  if (!discountCode) return null;

  if (/25$/i.test(discountCode)) {
    return { code: discountCode, rate: 0.27 };
  }

  // FRIEND-* (ReferralCandy friend codes) are a flat $20 off the order, not a
  // per-item percentage — there is no honest per-card preview, so cards keep
  // their regular prices and the cart sidebar carries the $20 off.
  if (discountCode === 'GET50' || discountCode.includes('50OFF')) {
    return { code: discountCode, rate: 0.50 };
  }

  return null;
}

function getCollectionCardPurchaseType() {
  if (window.__cartSidebar && window.__cartSidebar.purchaseType) {
    return window.__cartSidebar.purchaseType;
  }

  try {
    return localStorage.getItem('cs_purchase_type') || 'subscription';
  } catch (e) {
    return 'subscription';
  }
}

function getCollectionCardDiscountRate() {
  const discountConfig = getCollectionDiscountConfig();
  if (!discountConfig) return 0;
  if (getCollectionCardPurchaseType() !== 'subscription') return 0;

  return discountConfig.rate;
}

function updateCollectionCardPriceDisplay(wrapper, totalPriceCents, totalCompareAtPriceCents = totalPriceCents) {
  const priceRoot = wrapper.querySelector('.price');
  if (!priceRoot) return;

  const comparePriceEl = priceRoot.querySelector('.price__sale .price__compare .price-item--regular');
  const salePriceEl = priceRoot.querySelector('.price__sale .price-item--sale');
  const regularPriceEls = priceRoot.querySelectorAll('.price__regular .price-item--regular');
  const discountRate = getCollectionCardDiscountRate();
  const hasCompareAtSale = totalCompareAtPriceCents > totalPriceCents;
  const displayCompareAtPriceCents = hasCompareAtSale ? totalCompareAtPriceCents : totalPriceCents;

  if (!discountRate) {
    priceRoot.classList.toggle('price--on-sale', hasCompareAtSale);
    regularPriceEls.forEach((priceEl) => {
      priceEl.textContent = formatMoneyFromCents(totalPriceCents);
    });
    if (comparePriceEl) comparePriceEl.textContent = formatMoneyFromCents(displayCompareAtPriceCents);
    if (salePriceEl) salePriceEl.textContent = formatMoneyFromCents(totalPriceCents);
    return;
  }

  const subPriceCents = Math.round(totalPriceCents * 0.95);
  const discountedPriceCents = Math.round(subPriceCents * (1 - discountRate));

  priceRoot.classList.add('price--on-sale');

  regularPriceEls.forEach((priceEl) => {
    priceEl.textContent = formatMoneyFromCents(totalPriceCents);
  });

  if (comparePriceEl) {
    comparePriceEl.textContent = formatMoneyFromCents(displayCompareAtPriceCents);
  }

  if (salePriceEl) {
    salePriceEl.textContent = formatMoneyFromCents(discountedPriceCents);
  }
}

function applyCollectionCardDiscounts(root = document) {
  root.querySelectorAll('.card-wrapper').forEach((wrapper) => {
    const pillContainer = wrapper.querySelector('.card__protein-selector.protein-pills');
    const priceWrapper = wrapper.querySelector('.price-vendor-wrapper');
    const qtyInput = wrapper.querySelector('.quantity__input');

    let totalPriceCents = 0;
    let totalCompareAtPriceCents = 0;

    if (pillContainer) {
      const selectedPill = pillContainer.querySelector('.protein-pill.selected') || pillContainer.querySelector('.protein-pill');
      const basePriceCents = parseInt(pillContainer.dataset.basePriceCents || priceWrapper?.dataset.basePriceCents || '0', 10) || 0;
      const baseCompareAtPriceCents = parseInt(pillContainer.dataset.baseCompareAtPriceCents || priceWrapper?.dataset.baseCompareAtPriceCents || basePriceCents, 10) || basePriceCents;
      const proteinPriceCents = parseInt(selectedPill?.dataset?.proteinPriceCents || '0', 10) || 0;
      const proteinCompareAtPriceCents = parseInt(selectedPill?.dataset?.proteinCompareAtPriceCents || proteinPriceCents, 10) || proteinPriceCents;
      totalPriceCents = basePriceCents + proteinPriceCents;
      totalCompareAtPriceCents = baseCompareAtPriceCents + proteinCompareAtPriceCents;
    } else {
      totalPriceCents =
        parseInt(priceWrapper?.dataset.basePriceCents || qtyInput?.dataset.price || '0', 10) || 0;
      totalCompareAtPriceCents =
        parseInt(priceWrapper?.dataset.baseCompareAtPriceCents || totalPriceCents, 10) || totalPriceCents;
    }

    if (!totalPriceCents) return;
    updateCollectionCardPriceDisplay(wrapper, totalPriceCents, totalCompareAtPriceCents);
  });
}

function updateCardPriceForProtein(wrapper, select, option) {
  const basePriceCents = parseInt(select.dataset.basePriceCents || "0", 10) || 0;
  const baseCompareAtPriceCents = parseInt(select.dataset.baseCompareAtPriceCents || basePriceCents, 10) || basePriceCents;
  const proteinPriceCents = parseInt(option?.dataset?.proteinPriceCents || "0", 10) || 0;
  const proteinCompareAtPriceCents = parseInt(option?.dataset?.proteinCompareAtPriceCents || proteinPriceCents, 10) || proteinPriceCents;

  const totalPriceCents = basePriceCents + proteinPriceCents;
  const totalCompareAtPriceCents = baseCompareAtPriceCents + proteinCompareAtPriceCents;

  updateCollectionCardPriceDisplay(wrapper, totalPriceCents, totalCompareAtPriceCents);
}

/* ================================
   Protein Salad Name update helpers
   ================================ */

function updateCardTitleForProtein(wrapper, select) {
  const titleEl = wrapper.querySelector(".card-information__text.h2");
  if (!titleEl) return;

  const baseTitle = titleEl.dataset.baseTitle || titleEl.textContent.trim();
  const option = select.options[select.selectedIndex];

  // Salad Only (blank value)
  if (!select.value) {
    titleEl.textContent = baseTitle;
    return;
  }

  // Full replacement title stored on the option
  const fullTitle = option?.dataset?.proteinTitle;
  titleEl.textContent = (fullTitle && fullTitle.trim()) ? fullTitle.trim() : baseTitle;
}


/* ================================
   Protein selector – hydration helpers
   ================================ */

function isHydrating(select) {
  return select.dataset.hydrating === '1';
}

function setHydrating(select, on) {
  select.dataset.hydrating = on ? '1' : '0';
}


// Protein pill selector: update calories + card image + cart
document.addEventListener("click", function (event) {
  const pill = event.target.closest(".protein-pill");
  if (!pill) return;

  const pillContainer = pill.closest(".protein-pills");
  if (!pillContainer) return;

  const wrapper = pill.closest(".card-wrapper");
  if (!wrapper) return;

  // Update selected state
  pillContainer.querySelectorAll(".protein-pill").forEach(p => p.classList.remove("selected"));
  pill.classList.add("selected");

  // --- PRICE ---
  updateCardPriceForProteinPill(wrapper, pillContainer, pill);

  // --- CALORIES ---
  const baseCalories = parseInt(pillContainer.dataset.baseCalories || "0", 10) || 0;
  const proteinCalories = parseInt(pill.dataset.proteinCalories || "0", 10) || 0;
  const total = baseCalories + proteinCalories;

  const caloriesValueEl = wrapper.querySelector(".card__calories-value");
  if (caloriesValueEl) {
    caloriesValueEl.textContent = total;
  }

  /**
   * Protein variant images ship WITHOUT src/srcset — see the deferral comment in
   * snippets/product-card.liquid. They are stacked and cross-faded with opacity rather than
   * display:none, so if they carried real URLs the browser would download every variant on
   * page load (~400 KiB per menu) for images most customers never reveal.
   *
   * This promotes the deferred URLs to real attributes the first time a variant is about to
   * be shown. Idempotent: the dataset entries are removed once used, so repeated pill
   * clicks do nothing. srcset is set before src so the browser picks from the candidate
   * list rather than briefly committing to the src fallback.
   */
  function promoteDeferredProteinImage(img) {
    if (!img || !img.dataset || !img.dataset.deferredSrc) return;
    if (img.dataset.deferredSrcset) {
      img.setAttribute("srcset", img.dataset.deferredSrcset);
      delete img.dataset.deferredSrcset;
    }
    img.setAttribute("src", img.dataset.deferredSrc);
    delete img.dataset.deferredSrc;
  }

  // --- IMAGE SWAP ---
  const proteinVariantId = pill.dataset.value || ""; // "" when "Salad Only"
  // The hover-reveal image is driven by CSS only — excluding it here keeps the
  // protein swap from writing an inline opacity that would override :hover.
  const images = wrapper.querySelectorAll(
    ".card__media--protein .card__image:not(.card__image--hover)"
  );

  let hasMatch = false;

  images.forEach((img) => {
    const key = img.dataset.proteinImage; // "none" or variant id
    const shouldShow =
      (!proteinVariantId && key === "none") ||
      (proteinVariantId && key === proteinVariantId);

    if (shouldShow) {
      hasMatch = true;
      promoteDeferredProteinImage(img);
      img.classList.add("card__image--active");
      img.style.opacity = "1";
    } else {
      img.classList.remove("card__image--active");
      img.style.opacity = "0";
    }
  });

  if (!hasMatch) {
    images.forEach((img) => {
      if (img.dataset.proteinImage === "none") {
        promoteDeferredProteinImage(img);
        img.classList.add("card__image--active");
        img.style.opacity = "1";
      } else {
        img.classList.remove("card__image--active");
        img.style.opacity = "0";
      }
    });
  }

  // --- CART SWAP LOGIC ---
  // Skip cart operations entirely during hydration (no API calls needed)
  if (isHydrating(pillContainer)) return;

  const prevProteinId = pillContainer.dataset.selectedProteinId || "";
  const newProteinId = pill.dataset.value || "";
  pillContainer.dataset.selectedProteinId = newProteinId;

  // Nothing to do if it didn't actually change
  if (prevProteinId === newProteinId) return;

  // how many of THIS salad are on the card
  const qtyInput = wrapper.querySelector(".quantity__input");
  const saladQty = qtyInput ? parseInt(qtyInput.value || "0", 10) || 0 : 0;
  if (!saladQty) return;

  const baseVariantId = String(pillContainer.dataset.id || "");
  if (!baseVariantId) return;

  // Get salad title for the "Paired with" property
  const saladTitleEl = wrapper.querySelector('.card-information__text');
  const saladTitle = saladTitleEl ? (saladTitleEl.dataset.baseTitle || saladTitleEl.textContent || '').trim() : '';

  debounceCartUpdate(`protein:${baseVariantId}`, async () => {
    const cart = await getCart();

    // Find the SALAD line by variant_id in the cart
    const saladLine = cart.items.find(
      (i) => String(i.variant_id) === baseVariantId
    );

    // If user picked protein before adding the salad -> do not touch cart
    if (!saladLine) return;

    // Use cart quantity (source of truth)
    const qty = saladLine.quantity || 0;
    await updateProteinCartForSalad(prevProteinId, newProteinId, qty, saladTitle, cart);
  });
});

// Helper function for pill price updates
function updateCardPriceForProteinPill(wrapper, pillContainer, pill) {
  const basePriceCents = parseInt(pillContainer.dataset.basePriceCents || "0", 10) || 0;
  const baseCompareAtPriceCents = parseInt(pillContainer.dataset.baseCompareAtPriceCents || basePriceCents, 10) || basePriceCents;
  const proteinPriceCents = parseInt(pill.dataset.proteinPriceCents || "0", 10) || 0;
  const proteinCompareAtPriceCents = parseInt(pill.dataset.proteinCompareAtPriceCents || proteinPriceCents, 10) || proteinPriceCents;

  const totalPriceCents = basePriceCents + proteinPriceCents;
  const totalCompareAtPriceCents = baseCompareAtPriceCents + proteinCompareAtPriceCents;

  updateCollectionCardPriceDisplay(wrapper, totalPriceCents, totalCompareAtPriceCents);
}

async function updateProteinCartForSalad(prevProteinId, newProteinId, saladQty, saladTitle, existingCart) {
  try {
    let cart = existingCart || await getCart();

    // 1) Remove/reduce old bundle protein line for this salad
    if (prevProteinId && saladTitle) {
      const oldLine = findBundleLine(cart, prevProteinId, saladTitle);
      if (oldLine) {
        const newQty = Math.max(0, oldLine.quantity - saladQty);
        // cartChangeLine returns the updated cart (/cart/change.js response)
        cart = await cartChangeLine(oldLine.key, newQty);
      }
    }

    // 2) Add/increase new bundle protein line for this salad
    if (newProteinId && saladTitle) {
      // Use cart from step 1 (already updated) — no extra getCart needed
      const newLine = findBundleLine(cart, newProteinId, saladTitle);
      if (newLine) {
        cart = await cartChangeLine(newLine.key, newLine.quantity + saladQty);
      } else {
        // cartAdd returns added items (not full cart), so fetch cart after
        await cartAdd(newProteinId, saladQty, { 'Paired with': saladTitle });
        cart = await getCart();
      }
    }

    // 3) Refresh UI using the cart we already have
    if (typeof updateCartBubbles === "function") updateCartBubbles(cart);
    if (typeof updateCartProgress === "function") updateCartProgress(cart);
    if (typeof updateFreeShippingMessage === "function") updateFreeShippingMessage(cart.total_price / 100);
    if (typeof updatePopUpMessage === "function") updatePopUpMessage(cart.total_price / 100);
    if (typeof syncCollectionQuantities === "function") syncCollectionQuantities(cart);
    // Dispatch cart update event for collection cart minimum
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

    // 4) Sync standalone protein card inputs (show only non-bundle qty)
    syncStandaloneProteinInput(cart, prevProteinId);
    syncStandaloneProteinInput(cart, newProteinId);
  } catch (err) {
    console.error("Error updating protein in cart", err);
  }
}

// Sync standalone protein card quantity inputs (excludes bundle line quantities)
function syncStandaloneProteinInput(cart, variantId) {
  if (!variantId) return;
  const standaloneLine = findStandaloneLine(cart, variantId);
  const qty = standaloneLine ? standaloneLine.quantity : 0;

  document
    .querySelectorAll(`.quantity__input[data-id='${variantId}']`)
    .forEach((input) => {
      input.value = qty;
      const qiEl = input.closest("quantity-input");
      if (qiEl && typeof qiEl.handleMinusButton === "function") {
        qiEl.handleMinusButton();
      }
    });
}

// Default protein pill setup
document.addEventListener('DOMContentLoaded', () => {
  applyCollectionCardDiscounts();

  document.querySelectorAll('.protein-pills').forEach((pillContainer) => {
    // Read the default from the data attribute
    const defaultId = pillContainer.dataset.selectedProteinId || '';

    // Find the pill that matches the default, or fall back to first pill (Salad Only)
    const pills = pillContainer.querySelectorAll('.protein-pill');
    let targetPill = null;

    pills.forEach(pill => {
      pill.classList.remove('selected');
      if (defaultId && pill.dataset.value === defaultId) {
        targetPill = pill;
      }
    });

    // If no matching pill found, select the first one (Salad Only)
    if (!targetPill && pills.length > 0) {
      targetPill = pills[0];
    }

    if (targetPill) {
      targetPill.classList.add('selected');
      // Store the selected value
      pillContainer.dataset.selectedProteinId = targetPill.dataset.value || '';

      // Trigger the click handler to update price/calories/image
      targetPill.click();
    }
  });
});

document.addEventListener('cs:purchase-type-changed', function () {
  applyCollectionCardDiscounts(document.querySelector('#main-collection-product-grid') || document);
});

//debounce update
// Global debounce registry to avoid overlapping cart calls
const debouncedCartUpdates = {};

// Cart operation queue: serializes all cart mutations so only one runs at a time.
// Prevents concurrent API calls that trigger 429/409 cascades from Shopify.
let cartOperationQueue = Promise.resolve();
let cartOpsInFlight = 0;

function enqueueCartOperation(fn) {
  cartOpsInFlight++;
  if (cartOpsInFlight === 1) document.body.classList.add('cart-updating');

  const done = () => {
    cartOpsInFlight--;
    if (cartOpsInFlight === 0) document.body.classList.remove('cart-updating');
  };

  const op = cartOperationQueue.then(fn, fn).then(
    result => { done(); return result; },
    err    => { done(); throw err; }
  );
  cartOperationQueue = op.catch(() => {});
  return op;
}

function debounceCartUpdate(key, fn, delay = 50) {
  if (debouncedCartUpdates[key]) {
    clearTimeout(debouncedCartUpdates[key]);
  }
  debouncedCartUpdates[key] = setTimeout(() => enqueueCartOperation(fn), delay);
}

// Cart API helper: retries on 429 rate limit with progressive backoff
async function cartFetch(url, options = {}) {
  const defaults = {
    credentials: 'same-origin',
    cache: 'no-store',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
  };
  const opts = { ...defaults, ...options, headers: { ...defaults.headers, ...(options.headers || {}) } };
  for (let attempt = 0; attempt < 3; attempt++) {
    const res = await fetch(url, opts);
    if (res.status === 429 || res.status === 409) {
      await new Promise(r => setTimeout(r, 1500 * (attempt + 1)));
      continue;
    }
    if (!res.ok) throw new Error(`Cart API error: ${res.status}`);
    return res.json();
  }
  throw new Error(`Cart API error after retries: ${url}`);
}

async function getCart() {
  return cartFetch('/cart.js');
}

// Look up a ReCharge selling plan for a variant by finding its product handle from the DOM
async function getSellingPlanForVariant(variantId) {
  // Determine purchase type — prefer sidebar instance, fallback to localStorage
  var purchaseType = 'subscription';
  var sidebar = window.__cartSidebar;
  if (sidebar) {
    purchaseType = sidebar.purchaseType;
  } else {
    try { purchaseType = localStorage.getItem('cs_purchase_type') || 'subscription'; } catch (e) {}
  }
  if (purchaseType !== 'subscription') return null;

  // Find product handle from quantity-input or protein-pill in the DOM
  var handle = null;
  var qiEl = document.querySelector('quantity-input[data-id="' + variantId + '"]');
  if (qiEl && qiEl.dataset.handle) {
    handle = qiEl.dataset.handle;
  } else {
    var pillEl = document.querySelector('.protein-pill[data-value="' + variantId + '"]');
    if (pillEl && pillEl.dataset.handle) handle = pillEl.dataset.handle;
  }
  if (!handle) return null;

  // Use sidebar method if available
  if (sidebar && typeof sidebar.findSellingPlan === 'function') {
    var chargeDay = (sidebar.daySelect && sidebar.daySelect.value) ? sidebar.daySelect.value : sidebar.deliveryDay;
    return sidebar.findSellingPlan(handle, sidebar.frequency, chargeDay);
  }

  // Fallback: direct selling plan lookup when sidebar not yet initialized
  try {
    var TRANSLATION = { weekly: '1 week', biweekly: '2 week', monday: 'Monday', sunday: 'Sunday' };
    var freqStr = TRANSLATION['weekly']; // default frequency
    var resp = await fetch('/products/' + handle + '.js');
    var product = await resp.json();
    var groups = product.selling_plan_groups || [];
    for (var g = 0; g < groups.length; g++) {
      if (groups[g].app_id && String(groups[g].app_id) !== '294517') continue;
      var plans = groups[g].selling_plans || [];
      for (var p = 0; p < plans.length; p++) {
        if (plans[p].name.indexOf(freqStr) !== -1) return plans[p].id;
      }
    }
  } catch (e) {}
  return null;
}

// Add a line item to cart with optional properties and selling plan
async function cartAdd(variantId, quantity, properties = {}) {
  var item = {
    id: parseInt(variantId, 10),
    quantity: quantity,
    properties: properties
  };

  // Auto-include selling plan if subscription mode is active
  var sellingPlan = await getSellingPlanForVariant(variantId);
  if (sellingPlan) item.selling_plan = sellingPlan;

  return cartFetch('/cart/add.js', {
    method: 'POST',
    body: JSON.stringify({ items: [item] })
  });
}

// Change a specific line item's quantity by its unique key
async function cartChangeLine(lineKey, quantity) {
  return cartFetch('/cart/change.js', {
    method: 'POST',
    body: JSON.stringify({
      id: lineKey,
      quantity: quantity
    })
  });
}

// Find a bundle protein line: same variant + matching "Paired with" value
function findBundleLine(cart, variantId, saladTitle) {
  return cart.items.find(
    i => String(i.variant_id) === String(variantId)
      && i.properties && i.properties['Paired with'] === saladTitle
  );
}

// Find a standalone protein line: same variant, no "Paired with" property
function findStandaloneLine(cart, variantId) {
  return cart.items.find(
    i => String(i.variant_id) === String(variantId)
      && (!i.properties || !i.properties['Paired with'])
  );
}

// Check if any bundle line exists for a variant (any salad pairing)
function hasAnyBundleLine(cart, variantId) {
  return cart.items.some(
    i => String(i.variant_id) === String(variantId)
      && i.properties && i.properties['Paired with']
  );
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.previousValue = 0;
    this.input = this.querySelector('input') || this.querySelector('.quantity__input');
    this.minusButton = this.querySelector("button[name='minus']");
    this.changeEvent = new Event('change', { bubbles: true });
    this.handleMinusButton();

    /*
      If this instance is not registered, find the quantit-input button and register the reference.
    */
    if (!this.input) {
      this.input = document.querySelector("quantity-input input")
      return
    }
    this.previousValue = this.input.value * 1 || 0;
    // else {
    this.input.addEventListener("change", (e) => {
      this.handleMinusButton();
      const variant_id = e.target.dataset.id;
      const lineKey = e.target.dataset.lineKey;

      // Drawer line items have a lineKey — use /cart/change.js for precise targeting
      if (lineKey) {
        const quantity = this.input.value * 1;
        debounceCartUpdate(`change-${lineKey}`, async () => {
          await cartChangeLine(lineKey, quantity);
          const cart = await getCart();
          if (typeof updateCartBubbles === 'function') updateCartBubbles(cart);
          if (typeof updateCartProgress === 'function') updateCartProgress(cart);
          if (typeof updateFreeShippingMessage === 'function') updateFreeShippingMessage(cart.total_price / 100);
          if (typeof updatePopUpMessage === 'function') updatePopUpMessage(cart.total_price / 100);
          if (typeof syncCollectionQuantities === 'function') syncCollectionQuantities(cart);
          // Dispatch cart update event for collection cart minimum
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        });
        return;
      }

      console.log("in button click")
      //no salad delta
      /*
      let currentUrl = window.location.pathname
            if (currentUrl.includes("collections")) {

            const quantity = this.input.value * 1;
            const proteinSelect = document.querySelector(
              `select.card-protein-select[data-id='${variant_id}']`
            );

            // If this product has a protein dropdown, keep proteins in sync
            if (proteinSelect) {
              const selectedProteinId = proteinSelect.value; // "" or variant id
              const allProteinIds = (proteinSelect.dataset.proteinIds || '')
                .split(',')
                .map(id => id.trim())
                .filter(Boolean);

              const updates = {};
              // main salad variant
              updates[variant_id] = quantity;

              // for each possible protein, set qty = salad qty if selected, else 0
              allProteinIds.forEach(id => {
                if (!id) return;
                updates[id] = (selectedProteinId && id === selectedProteinId) ? quantity : 0;
              });

              const cartUpdateaa = this.updateQuantityMultiple(updates);
              cartUpdateaa.then(cart => {
                // sync all visible quantity-inputs to match cart
                this.updateInputQuantity(variant_id, quantity);

                if (selectedProteinId) {
                  this.updateInputQuantity(selectedProteinId, quantity);
                }
                // zero out other proteins visually
                allProteinIds.forEach(id => {
                  if (id && id !== selectedProteinId) {
                    this.updateInputQuantity(id, 0);
                  }
                });

                updateCartBubbles(cart);
                updateCartProgress(cart);
                updateFreeShippingMessage(cart.total_price / 100);
                updatePopUpMessage(cart.total_price / 100);
              });
            } else {
              // No protein selector on this card: original behaviour
              const cartUpdateaa = this.updateQuantity(variant_id, quantity);
              cartUpdateaa.then(cart => {
                updateCartBubbles(cart);
                updateCartProgress(cart)
                updateFreeShippingMessage(cart.total_price / 100);
                updatePopUpMessage(cart.total_price / 100);
              });
            }
          }
      */
      
      //below is with salad delta
            let currentUrl = window.location.pathname;

      if (currentUrl.includes("collections")) {
        const quantity = this.input.value * 1;
        // Track new item adds (0 → positive) for subscription selling plan handling
        if (this.previousValue === 0 && quantity > 0) this._isNewItemAdd = true;

        // Scope to the card that was actually tapped. A product can render in
        // more than one category section, and a bare document-wide lookup
        // always returns the first copy — pairing the protein that copy has
        // selected instead of this one. The quick-view popup's stepper lives
        // outside any card, so keep the document lookup as the fallback.
        const tappedCard = this.closest('.card-wrapper');
        const proteinPillsForThisSalad =
          (tappedCard && tappedCard.querySelector(`.protein-pills[data-id='${variant_id}']`)) ||
          document.querySelector(`.protein-pills[data-id='${variant_id}']`);

        // If this product has protein pills (it's a salad card)
        if (proteinPillsForThisSalad) {
          const selectedPill = proteinPillsForThisSalad.querySelector('.protein-pill.selected');
          const proteinId = selectedPill ? (selectedPill.dataset.value || '') : '';
          const saladWrapper = proteinPillsForThisSalad.closest('.card-wrapper');
          const saladTitleEl = saladWrapper ? saladWrapper.querySelector('.card-information__text') : null;
          const saladTitle = saladTitleEl ? (saladTitleEl.dataset.baseTitle || saladTitleEl.textContent || '').trim() : '';

          debounceCartUpdate(`update-${variant_id}`, async () => {
            // 1) Update/add salad quantity
            const isNew = this._isNewItemAdd; this._isNewItemAdd = false;
            let cart;
            if (isNew && window.__cartSidebar && window.__cartSidebar.purchaseType === 'subscription') {
              await cartAdd(variant_id, quantity, {});
              cart = await getCart();
            } else {
              cart = await this.updateQuantity(variant_id, quantity);
            }

            // 2) Handle this salad's bundle protein line
            if (proteinId && saladTitle) {
              const bundleLine = findBundleLine(cart, proteinId, saladTitle);
              if (quantity > 0) {
                if (bundleLine) {
                  if (bundleLine.quantity !== quantity) {
                    cart = await cartChangeLine(bundleLine.key, quantity);
                  }
                } else {
                  await cartAdd(proteinId, quantity, { 'Paired with': saladTitle });
                  cart = await getCart();
                }
              } else if (bundleLine) {
                cart = await cartChangeLine(bundleLine.key, 0);
              }
            } else if (!proteinId && saladTitle && quantity === 0) {
              // Salad removed with "Salad Only" — clean up any stale bundle lines
              const knownProteinIds = (proteinPillsForThisSalad.dataset.proteinIds || '')
                .split(',').map(id => id.trim()).filter(Boolean);
              for (const pid of knownProteinIds) {
                const bundleLine = findBundleLine(cart, pid, saladTitle);
                if (bundleLine) {
                  cart = await cartChangeLine(bundleLine.key, 0);
                }
              }
            }

            // 3) Refresh UI using the cart we already have
            this.updateInputQuantity(variant_id, quantity);
            const allProteinIds = (proteinPillsForThisSalad.dataset.proteinIds || '')
              .split(',').map(id => id.trim()).filter(Boolean);
            allProteinIds.forEach(id => syncStandaloneProteinInput(cart, id));

            updateCartBubbles(cart);
            updateCartProgress(cart);
            updateFreeShippingMessage(cart.total_price / 100);
            updatePopUpMessage(cart.total_price / 100);
            if (typeof syncCollectionQuantities === 'function') syncCollectionQuantities(cart);
            // Dispatch cart update event for collection cart minimum
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          });
        } else {
          // No protein selector on this card
          // Check DOM to see if any salad pill container references this variant as a protein
          const couldHaveBundleLines = !!document.querySelector(
            `.protein-pills[data-protein-ids*="${variant_id}"]`
          );

          debounceCartUpdate(`update-${variant_id}`, async () => {
            const isNew = this._isNewItemAdd; this._isNewItemAdd = false;
            if (couldHaveBundleLines) {
              // Standalone protein card that might share variants with bundle lines
              const cart = await getCart();
              const standaloneLine = findStandaloneLine(cart, variant_id);
              let updatedCart;
              if (standaloneLine) {
                updatedCart = await cartChangeLine(standaloneLine.key, quantity);
              } else if (quantity > 0) {
                await cartAdd(variant_id, quantity, {});
                updatedCart = await getCart();
              } else {
                updatedCart = cart;
              }
              updateCartBubbles(updatedCart);
              updateCartProgress(updatedCart);
              updateFreeShippingMessage(updatedCart.total_price / 100);
              updatePopUpMessage(updatedCart.total_price / 100);
              if (typeof syncCollectionQuantities === 'function') syncCollectionQuantities(updatedCart);
              // Dispatch cart update event for collection cart minimum
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: updatedCart }));
            } else {
              // No bundle lines possible — single API call
              let updatedCart;
              if (isNew && window.__cartSidebar && window.__cartSidebar.purchaseType === 'subscription') {
                await cartAdd(variant_id, quantity, {});
                updatedCart = await getCart();
              } else {
                updatedCart = await this.updateQuantity(variant_id, quantity);
              }
              updateCartBubbles(updatedCart);
              updateCartProgress(updatedCart);
              updateFreeShippingMessage(updatedCart.total_price / 100);
              updatePopUpMessage(updatedCart.total_price / 100);
              if (typeof syncCollectionQuantities === 'function') syncCollectionQuantities(updatedCart);
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: updatedCart }));
            }
          });
        }
      }

      this.updateInputQuantity(variant_id, e.target.value);
    })

    // NEWSTUFF
    this.querySelectorAll('button').forEach(
      (button) => {
        button.addEventListener('click', this.onButtonClick.bind(this))
        //button.addEventListener('lockQuantity', this.lockButton.bind(this))
      }
    );

    // }
  }

  handleSingle(single_bundle, variant_id, quantity, addon_id) {
    if (single_bundle) {
      setSingleBundle(variant_id, quantity, addon_id)
    }
  }

  onButtonClick(event) {
    event.preventDefault();

    const button = event.currentTarget;
    if (!button) return;

    button.setAttribute('disabled', '');
    
    const previousValue = this.input.value;
    this.previousValue = this.input.value * 1;

    button.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    button.removeAttribute('disabled');
  }
  updateQuantity(id, quantity) {
    return cartFetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify({ updates: { [id]: quantity } })
    });
  }
  updateQuantityMultiple(update) {
    return cartFetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify({ updates: update })
    });
  }

  handleMinusButton() {
    if (!this.input) return;

    const isEmpty = Number(this.input.value) === 0;
    this.classList.toggle('quantity--empty', isEmpty);

    if (this.minusButton) {
      this.minusButton.disabled = isEmpty;
    }
  }

  /*
    Updates the quantity in the Quantity Input component to reflect the new quantity.
  */
  updateInputQuantity(variant_id, quantity) {
    const QuantityInputs = document.querySelectorAll(`quantity-input[data-id='${variant_id}']`);
    QuantityInputs.forEach(quantityInput => {
      quantityInput.input.value = quantity;
      quantityInput.previousValue = quantity * 1 || 0;
      quantityInput.handleMinusButton();
    })
  }

  getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    })
      .then((res) => res.json())
      .then((res) => res);
  }
}

customElements.define('quantity-input', QuantityInput);


class AddOnCheck extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input')

    this.input.addEventListener("change", (e) => {

      const variant_id = e.target.dataset.variant;
      var quantity = e.target.dataset.quantity;
      // APPSTLE REMOVED: Removed Appstle_Subscriber check, keeping logic for all users
      const QuantityInputs = document.querySelectorAll(`quantity-input[data-id='${e.target.dataset.id}']`)[0];
      var cartUpdate = {};

      if (e.target.checked) {
        this.checkedInput(quantity, QuantityInputs, e, variant_id)
      } else {
        this.unCheckedInput(variant_id, QuantityInputs, quantity, e.target.dataset.id, e)
      }
      this.handleAllChecked(e.target.checked, e.target.dataset.id)
    })

  }

  handleAllChecked(checked, variant_id) {
    const QuantityInputs = document.querySelectorAll(`addon-overlay input[data-id='${variant_id}']`);
    QuantityInputs.forEach(quantityInput => {
      quantityInput.checked = checked;
    })

  }

  updateInputQuantity(variant_id, quantity) {
    const QuantityInputs = document.querySelectorAll(`quantity-input[data-id='${variant_id}']`);
    QuantityInputs.forEach(quantityInput => {
      quantityInput.input.value = quantity;
      quantityInput.previousValue = quantity * 1 || 0;
      quantityInput.handleMinusButton();
    })
  }

  checkedInput(quantity, QuantityInputs, e, variant_id) {
    if (QuantityInputs.input.value > 0) {
      quantity = (QuantityInputs.input.value) * quantity;
    }
    else {
      quantity = (1) * quantity;
    }
    var previous_quantity = 0
    var i_q = 0
    this.getCart().then(res => {
      res.items.forEach(item => {
        if (item.id == variant_id) {
          previous_quantity += item.quantity;
        }
        if (item.id == e.target.dataset.id) {
          i_q = item.quantity;
        }
      });
      quantity += previous_quantity;
      if (QuantityInputs.input.value <= 0) {
        var p = 1
        if (e.target.dataset.single_bundle) {
          p = 0;
        }
        this.updateQuantity(
          {
            [variant_id]: quantity,
            [e.target.dataset.id]: p
          }).then(res => {
            updateCartBubbles(res);
            updateCartProgress(res)
            updateFreeShippingMessage(res.total_price / 100);
            updatePopUpMessage(res.total_price / 100);

            // NEW: sync protein card (e.g. Chicken / Sirloin) to actual quantity
            this.updateInputQuantity(variant_id, quantity);

            // Existing: sync main product card
            this.updateInputQuantity(e.target.dataset.id, 1)

            setAddOns(e.target.dataset.id, res.token)
            this.handleSingle(e, quantity, variant_id);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: res }));
          })
      } else {
        if (e.target.dataset.single_bundle) {
          i_q = 0;
        }
        this.updateQuantity({
          [variant_id]: quantity,
          [e.target.dataset.id]: i_q
        }).then(res => {
          updateCartBubbles(res);
          updateCartProgress(res)
          updateFreeShippingMessage(res.total_price / 100);
          updatePopUpMessage(res.total_price / 100);

          // NEW
          this.updateInputQuantity(variant_id, quantity);

          setAddOns(e.target.dataset.id, res.token)
          this.handleSingle(e, quantity, variant_id)
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: res }));
        })
      }
    });
  }


  unCheckedInput(variant_id, QuantityInputs, quantity, v_id, e) {
    var previous_quantity = 0
    this.getCart().then(res => {
      res.items.forEach(item => {
        if (item.id == variant_id) {
          previous_quantity += item.quantity;
        }
      });
      quantity = previous_quantity - QuantityInputs.input.value * quantity;
      if (quantity < 0)
        quantity = 0;
      // if(e.target.dataset.single_bundle){
      //   quantity = quantity/e.target.dataset.quantity;
      // }
      this.updateQuantity({
        [variant_id]: quantity,
        [v_id]: QuantityInputs.input.value
      }).then(res => {
        updateCartBubbles(res);
        updateCartProgress(res);
        updateFreeShippingMessage(res.total_price / 100);
        updatePopUpMessage(res.total_price / 100);
        removeVariantId(v_id)
        this.handleSingle(e, 0, variant_id)

        // NEW: sync protein card (likely to 0 when fully unchecked)
        this.updateInputQuantity(variant_id, quantity);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: res }));
      })
    })
  }

  handleSingle(e, quantity, addon_id) {
    if (e.target.dataset.single_bundle) {
      setSingleBundle(e.target.dataset.id, (quantity / e.target.dataset.quantity), addon_id)
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }


  updateQuantity(updates) {
    const body = {
      updates: updates
    }
    return fetch('/cart/update.js', {
      method: "POST",

      credentials: 'same-origin',
      cache: 'no-store',

      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then((res) => res.json())
      .then((res) => res);
  }

  getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    })
      .then((res) => res.json())
      .then((res) => res);
  }

}

customElements.define('addon-overlay', AddOnCheck);



function setAddOns(variant_id, token) {
  var aad = localStorage.getItem('addons')
  if (aad) {
    try {
      aad = JSON.parse(localStorage.getItem('addons'))
      aad['key'] = token;
      aad['variant_ids'].push(variant_id);
      localStorage.setItem('addons', JSON.stringify(aad))
      return
    }
    catch (error) {
    }
  }
  localStorage.setItem('addons', JSON.stringify({ 'key': token, 'variant_ids': [variant_id] }))
}

function setSingleBundle(variant_id, quantity, addon_id) {
  addon_id = addon_id.toString()
  variant_id = variant_id.toString()
  var aad = localStorage.getItem('single_bundle')
  if (aad) {
    try {
      aad = JSON.parse(localStorage.getItem('single_bundle'))
      if (aad[addon_id]) {
        aad[addon_id][variant_id] = quantity;
      }
      else {
        aad[addon_id] = {};
        aad[addon_id][variant_id] = quantity
      }
      localStorage.setItem('single_bundle', JSON.stringify(aad))
      return
    }
    catch (error) {
    }
  }
  var x = {}
  x[addon_id] = {};
  x[addon_id][variant_id] = quantity
  localStorage.setItem('single_bundle', JSON.stringify(x))
}


function removeVariantId(variant_id) {

  var aad = localStorage.getItem('addons')
  if (aad) {
    try {
      aad = JSON.parse(localStorage.getItem('addons'))
      var filteredArray = aad['variant_ids'].filter(function (e) { return e !== variant_id.toString() })
      aad['variant_ids'] = filteredArray

      localStorage.setItem('addons', JSON.stringify(aad))
      return
    }
    catch (error) {
    }
  }


}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

const formToObject = form => {
  const obj = {}
  const formData = new FormData(form)
  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }
  return obj
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` },
    credentials: 'same-origin',
    cache: 'no-store'

  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({ behavior: "smooth" }); });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

function cartHandler(arg) {
}

function mapLineItmes(items) {
  return items.map(item => ({
    id: item.id,
    key: item.key,
    variantId: item.variant_id,
    price: item.final_price / 100,
    quantity: item.quantity,
    image: item.image,
    title: item.title,
    properties: item.properties || {}
  }))
}

// the below function is causing a error
function updateCartBubbles(cart) {
  console.log("in cart update");

  const formatMoney = (n) => "$" + Number(n || 0).toFixed(2);

  const getCountry = () => {
    const part = window.location.hostname.split(".")[1];
    return part === "com" ? "USA" : "Canada";
  };

  // Update header bubbles
  const cartCounts = document.querySelectorAll(".cart-count-bubble [aria-hidden]");
  for (const cartCount of cartCounts) cartCount.innerText = cart.item_count;

  // Templates must exist
  const overlayTpl = document.getElementById("drawerOverlayTemplate");
  const itemTpl = document.getElementById("drawerItemTemplate");
  if (!overlayTpl || !itemTpl) return;

  // Build OFF-DOM drawer so we can reuse the theme's exact markup
  const overlayClone = overlayTpl.cloneNode(true);
  const drawerClone = overlayClone.content.querySelector(".drawer-overlay");
  if (!drawerClone) return;

  const templateDrawerItem = itemTpl.content.querySelector(".item");
  const cloneItemsContainer = drawerClone.querySelector(".items-container");
  if (!templateDrawerItem || !cloneItemsContainer) return;

  // Convert cart to lineItems
  const lineItems = mapLineItmes(cart.items);

  // Render items into OFF-DOM container
  cloneItemsContainer.innerHTML = "";
  renderItems(lineItems, cloneItemsContainer, templateDrawerItem);

  // ---- KEY CHANGE ----
  // Instead of replacing the whole popup drawer (which can break +/- wiring),
  // only replace the items HTML inside the *existing* DOM drawer.
  const popupRoot = document.getElementById("popupDrawer") || document;
  const liveItemsContainer = popupRoot.querySelector(".items-container");
  if (!liveItemsContainer) return;

  liveItemsContainer.innerHTML = cloneItemsContainer.innerHTML;

  // Hide loader (live)
  const liveLoader = popupRoot.querySelector(".loader");
  if (liveLoader) liveLoader.style.display = "none";

  // ---- Drive quantities from cart, but DO NOT remove buttons/controls ----
  // Index-based mapping avoids duplicate titles.
  const liveRows = popupRoot.querySelectorAll(".items-container .item");
  const n = Math.min(liveRows.length, lineItems.length);

  let quantTotal = 0;
  let subtotalFromRows = 0;

  for (let i = 0; i < n; i++) {
    const row = liveRows[i];
    const li = lineItems[i];

    const qty = Number(li.quantity || 0);
    const unit = Number(li.price || 0);
    const lineTotal = qty * unit;

    // Set qty ONLY on the input value, keep +/- intact
    const qtyInput = row.querySelector(".quantity__input");
    if (qtyInput) {
      qtyInput.value = String(qty);
      qtyInput.setAttribute("value", String(qty));
    }

    // Update displayed price
    const priceEl = row.querySelector(".price");
    if (priceEl) priceEl.textContent = formatMoney(lineTotal);

    quantTotal += qty;
    subtotalFromRows += lineTotal;
  }

  // Update drawer item count display
  const qtyEl = popupRoot.querySelector(".item-quantity");
  if (qtyEl) qtyEl.textContent = String(cart.item_count);

  // Totals + messaging from cart totals (source of truth)
  const country = getCountry();
  const subtotal = cart.total_price / 100;
  const priceAfterDiscount = cart.original_total_price / 100;

  const subtotalEl = popupRoot.querySelector(".subtotal .price");
  const shippingEl = popupRoot.querySelector(".shipping .price");
  const grandEl = popupRoot.querySelector(".grandtotal .price");
  const msgEl = popupRoot.querySelector(".message");

  if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);

  let shippingTotal = country === "USA" ? 9.95 : 6.95;
  if (country !== "USA" && subtotal >= 65) shippingTotal = "Free";

  if (shippingEl && country !== "USA") {
    shippingEl.textContent = shippingTotal === "Free" ? "Free" : formatMoney(shippingTotal);
  }

  let grand = subtotal;
  if (shippingTotal !== "Free") grand += shippingTotal;

  if (grandEl && country !== "USA") {
    grandEl.textContent = formatMoney(grand);
  }

  // Canada banner logic (kept)
  const discount_code = getCookie("discount_code");

  if (country === "Canada" && msgEl) {
    if (!lineItems.length) {
      msgEl.textContent = "YOUR CART IS EMPTY";
    } else {
      if (discount_code === "GET50") {
        if (priceAfterDiscount < 40) {
          msgEl.innerHTML = "YOU ARE BELOW THE $40.00 MIN ORDER AMOUNT BEFORE DISCOUNT.";
        } else {
          const away = 65 - priceAfterDiscount;
          if (away > 0) {
            msgEl.innerHTML = `ONLY <span class="red-price">${formatMoney(away)}</span> AWAY FROM FREE DELIVERY`;
          } else {
            msgEl.innerHTML = "YOU HAVE FREE SHIPPING!";
          }
        }
      } else {
        if (subtotal < 40) {
          msgEl.innerHTML = "YOU ARE BELOW THE $40.00 MIN ORDER AMOUNT.";
        } else {
          const away = 65 - subtotal;
          if (away > 0) {
            msgEl.innerHTML = `ONLY <span class="red-price">${formatMoney(away)}</span> AWAY FROM FREE DELIVERY`;
          } else {
            msgEl.innerHTML = "YOU HAVE FREE SHIPPING!";
          }
        }
      }
    }
  }

  // Close button (avoid duplicates)
  const closeBtn = popupRoot.querySelector(".drawer__close-button") || document.querySelector(".drawer__close-button");
  if (closeBtn) {
    closeBtn.removeEventListener("click", closeDrawer);
    closeBtn.addEventListener("click", closeDrawer);
  }

  // OPTIONAL: If your theme has a quantity initializer, call it here.
  // Example (ONLY if it exists in your theme):
  // if (window.initCartQuantityControls) window.initCartQuantityControls(popupRoot);
}

  
var free_gift_id = "40483132735530";
var free_gift_handle_name = "organika-keto-mini-cookies"
//commented out the remove free gift code so there is no get error on the menu page when zeroing out a product
async function updateCartProgress(data) {
  if (((data || {}).items || []).length == 1 && data.items[0].id == free_gift_id) {
    //removeFreeGift()
  }
  else if (((data || {}).items || []).length > 0) {
    if (data.items.filter(item => item.id == free_gift_id).length == 0)
      addFreeGift();
    else if(!free_gift_is_active){
      //removeFreeGift()
    }
  }
  else
    //removeFreeGift()
  if (document.getElementById("collection_progress_overlay")) {
    var dela = ms => new Promise(res => setTimeout(res, ms));

    try {
      var free_delivery = 6500;
      var minimum_order = 4000;
      var free_gift = 8500;
      var has_selling_plan_allocation = false;
      var items = ((data || {}).items || [])
      items.forEach(item => {
        if (Object.keys(item.selling_plan_allocation || {}).length > 0) {
          has_selling_plan_allocation = true;
        }
      })
      if (has_selling_plan_allocation) {
        free_delivery = 6500;
        minimum_order = 3800;
      }
      if (data.total_price < free_gift) {
        removeFreeGift()
      }

      if (data.total_price >= free_gift) {
        update_rewards_overlay_milestone(100, "minimum-order")
        await dela(210)
        add_circle_progress("free-delivery")
        update_rewards_overlay_milestone(100, "free-delivery")
        await dela(210)
        add_circle_progress("free-gift")
        update_rewards_overlay_milestone(100, "free-gift")
        await dela(210)
        add_circle_progress("end")
        await addFreeGift()
        update_message_overlay(`Hooray! You unlocked free gift 🎉`)

      }
      else if (data.total_price >= free_delivery) {
        remove_circle_progress("end")
        update_rewards_overlay_milestone(100, "minimum-order")
        await dela(210)
        add_circle_progress("free-delivery")
        update_rewards_overlay_milestone(100, "free-delivery")
        await dela(210)
        add_circle_progress("free-gift")
        update_rewards_overlay_milestone(0, "free-gift")

        update_rewards_overlay_milestone((data.total_price / free_gift) * 100, "free-gift")
        var x = ((free_gift - data.total_price) / 100).toFixed(2)
        update_message_overlay(`Add $${x} to your cart to unlock free gift.`)


      } else if (data.total_price >= minimum_order) {
        remove_circle_progress("end")
        update_rewards_overlay_milestone(0, "free-gift")
        await dela(210)
        remove_circle_progress("free-gift")
        update_rewards_overlay_milestone(100, "minimum-order")
        await dela(210)
        add_circle_progress("free-delivery")
        update_rewards_overlay_milestone((data.total_price / free_delivery) * 100, "free-delivery")
        var x = ((free_delivery - data.total_price) / 100).toFixed(2)
        update_message_overlay(`Add $${x} to your cart to unlock free delivery.`)
      } else {
        remove_circle_progress("end")
        update_rewards_overlay_milestone(0, "free-gift")
        await dela(210)
        remove_circle_progress("free-gift")
        update_rewards_overlay_milestone(0, "free-delivery")
        await dela(210)
        remove_circle_progress("free-delivery")
        update_rewards_overlay_milestone((data.total_price / minimum_order) * 100, "minimum-order")
        var x = ((minimum_order - data.total_price) / 100).toFixed(2)
        update_message_overlay(`Add $${x} to your cart to meet the minimum order amount.`)
      }
    } catch (err) {
      console.log(err)
    }

  }
}
var free_gift_is_active = false;

async function check_free_gift(){
  var free_gift_check = await fetch(`/products/${free_gift_handle_name}.js`)
  if(free_gift_check.status==200){
    free_gift_is_active = true;
  }  
}
//check_free_gift() //removed as this is returning a 404 error from Shopify

async function addFreeGift() {
  if (free_gift_is_active) {
    var data = { "items": [{ "id": free_gift_id, "quantity": 1 }] }
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    })
    await res.json()
    res = await fetch("/cart.js")
    var r = await res.json();
    updateCartBubbles(r)
  }
  else{
    //removeFreeGift(); //removed for call to update that comes back no product avaliable
  }
}

async function removeFreeGift() {
  var data = { "updates": {} }
  data['updates'][free_gift_id] = 0
  var res = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
  var r = await res.json()
  //updateCartBubbles(r) //duplicate call causing cart to have undefined

}
function update_rewards_overlay_milestone(percentage, order) {
  var progress_overlay = document.getElementById("collection_progress_overlay")
  progress_overlay.querySelector(`.reward-progress-background-bar.${order}`).style = `width:${percentage}%`;

}
function update_message_overlay(message) {
  var progress_overlay = document.getElementById("collection_progress_overlay")
  progress_overlay.querySelector(`.reward-progress-message`).innerHTML = `${message}`;
}
function add_circle_progress(selector) {
  var progress_overlay = document.getElementById("collection_progress_overlay")
  progress_overlay.querySelector(`.progress-circle.${selector}`).classList.add('green')

}
function remove_circle_progress(selector) {
  var progress_overlay = document.getElementById("collection_progress_overlay")
  progress_overlay.querySelector(`.progress-circle.${selector}`).classList.remove('green')
}


function removeLockedMilestone(selector) {
  var progress_overlay = document.getElementById("collection_progress_overlay")
  progress_overlay.querySelector(`.${selector} .reward-icon`).classList.remove('d-none')
  progress_overlay.querySelector(`.${selector} .reward-icon-lock`).classList.add('d-none')
}
function addLockedMilestone(selector) {
  var progress_overlay = document.getElementById("collection_progress_overlay")
  progress_overlay.querySelector(`.${selector} .reward-icon`).classList.add('d-none')
  progress_overlay.querySelector(`.${selector} .reward-icon-lock`).classList.remove('d-none')
}

function closeDrawer() {
  var drawerPopup = document.querySelector("#popupDrawer");
  var drawer = ""
  drawerPopup.classList.add("closing-drawer");
  setTimeout(() => {
    drawerPopup.classList.remove("closing-drawer");
    drawerPopup.style.display = "none";
    if (!drawer) {
      drawer = document.querySelector(".drawer-overlay")
    }
    drawer.style.display = "none";
  }, 500);
};
function renderItems(lineItems, drawerItems, templateDrawerItem) {
  lineItems.forEach((lineItem) => {
    const { id, key, image, price, title, quantity, variantId, properties } = lineItem;
    const item = templateDrawerItem.cloneNode(true);
    const productImage = item.querySelector("img");
    const productTitle = item.querySelector(".title");
    const productQuantity = item.querySelector(".quantity__input");
    const productPrice = item.querySelector(".price");

    productImage.src = image;
    productTitle.innerText = title;
    productQuantity.setAttribute('value', quantity);
    productQuantity.dataset.id = variantId;
    if (key) productQuantity.dataset.lineKey = key;
    productQuantity.dataset.price = price * 100; //price was divided by 100
    productPrice.innerText = "$" + (price * quantity).toFixed(2);
    if (price == 0) {
      item.querySelector("quantity-input").innerHTML = "";
      item.querySelector("quantity-input").style = "border:none;";
    }

    // Show "Paired with" subtitle for bundle protein items
    if (properties && properties['Paired with']) {
      productTitle.innerHTML = title + '<br><span class="paired-with-label">Paired with ' + properties['Paired with'] + '</span>';
    }

    drawerItems.appendChild(item);
  });
}

//synchronize height on product card
//commented out as depricated from changes to css files
//document.addEventListener("readystatechange", (e) => {
//setEqualHeightToProduct();
//setTimeout(setEqualHeightToProduct, 2000);
//})

function setEqualHeightToProduct() {
  let itemPerRow;
  if (window.innerWidth < 990 && window.innerWidth >= 750) {
    itemPerRow = 3;
  } else if (window.innerWidth < 750) {
    itemPerRow = 2;
  } else {
    itemPerRow = 4;
  }

  const collection =
    document.querySelector("#main-collection-product-grid") ||
    document.querySelector("#product-grid");
  const productsCount = collection.childElementCount;
  const rowCount = Math.ceil(productsCount / itemPerRow);

  for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
    const row = [];
    for (let productIndex = 1; productIndex <= itemPerRow; productIndex++) {
      const product = collection.querySelector(
        `.grid__item:nth-child(${(rowIndex * itemPerRow) + productIndex})`
      );
      if (product) row.push(product)
    }

    //set equal title height
    const productTitles = row.map(card => card.querySelector(".card-information__text.h2"));
    const productTitleHeights = productTitles.map(wrapper => wrapper.offsetHeight);
    const maxProductTitleHeight = Math.max(...productTitleHeights);
    productTitles.forEach(wrapper => wrapper.style.height = maxProductTitleHeight + "px");

    //set equal price wrapper height
    const priceWrappers = row.map(card => card.querySelector(".price-vendor-wrapper"));
    const priceWrapperHeights = priceWrappers.map(wrapper => wrapper.offsetHeight);
    const maxPriceWrapperHeight = Math.max(...priceWrapperHeights);
    priceWrappers.forEach(wrapper => wrapper.style.height = maxPriceWrapperHeight + "px");
  }
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie;
  try {
    decodedCookie = decodeURIComponent(document.cookie);
  } catch (e) {
    decodedCookie = document.cookie;
  }
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

function loadHeaderSizes() {
  shippingBarSticky = document.querySelector('.shipping-bar-container-inner');
  announcementBar = document.querySelector('.announcement-bar');
  header = document.querySelector('.header-wrapper');
  threshold = announcementBar.offsetHeight + header.offsetHeight;
}

function checkDiscount() {
  var discount_code = getCookie("discount_code");
  if (discount_code != null) {
    showDiscountMessage();
  }
}

function showDiscountMessage() {
  const discountMessage = document.querySelector('.discount-message');
  if(discountMessage) {
    discountMessage.classList.add('is-visible');
  }
}

function setupListeners() {
  const collectionBoxes = document.querySelectorAll('[data-shg-href]');
  collectionBoxes.forEach((collectionBox) => {
    collectionBox.addEventListener('click', () => {
      const link = collectionBox.querySelector('a');
      if(link) {
        link.click();
      }
    });
  });
}

let lastScrollTop = 0;

let shippingBarSticky, announcementBar, header, threshold;

document.addEventListener('DOMContentLoaded', async  () => {
  console.log("in setup for discount")
  //loadHeaderSizes();
  checkDiscount();
  setupListeners();

    // --- Protein pill init / cart sync ---
  // Single cart fetch for hydration — no additional API calls needed
  const cart = await cartFetch('/cart.js');

  // A/B test: when cart is empty ($0), use the template flag to determine default
  const abTestProteinDefault = window.PROTEIN_DEFAULT_ENABLED === true && cart.total_price === 0;

  document.querySelectorAll('.protein-pills').forEach(pillContainer => {
    pillContainer.dataset.hydrating = '1';

    let selectedValue = pillContainer.dataset.selectedProteinId || '';

    // Derive selected protein from cart: find a protein line with "Paired with" matching this salad
    const wrapper = pillContainer.closest('.card-wrapper');
    const titleEl = wrapper ? wrapper.querySelector('.card-information__text') : null;
    const saladTitle = titleEl ? (titleEl.dataset.baseTitle || titleEl.textContent || '').trim() : '';

    // Check all protein IDs for this salad card to find one paired in the cart
    const proteinIds = (pillContainer.dataset.proteinIds || '').split(',').map(id => id.trim()).filter(Boolean);
    const pairedProteinLine = saladTitle
      ? cart.items.find(i => proteinIds.includes(String(i.variant_id)) && i.properties && i.properties['Paired with'] === saladTitle)
      : null;

    if (pairedProteinLine) {
      // Cart has a bundle protein for this salad — use it as source of truth
      selectedValue = String(pairedProteinLine.variant_id);
    } else if (abTestProteinDefault) {
      // A/B test: cart is $0 and flag is true — default to first protein (2nd pill)
      const pills = pillContainer.querySelectorAll('.protein-pill');
      if (pills.length > 1 && pills[1].dataset.value) {
        selectedValue = pills[1].dataset.value;
      }
    }

    // Find and select the matching pill
    const pills = pillContainer.querySelectorAll('.protein-pill');
    pills.forEach(pill => {
      pill.classList.remove('selected');
      if (pill.dataset.value === selectedValue) {
        pill.classList.add('selected');
        pillContainer.dataset.selectedProteinId = selectedValue;
        pill.click(); // Update UI (image + calories)
      }
    });

    // If nothing selected, select first pill (Salad Only)
    if (!pillContainer.querySelector('.protein-pill.selected') && pills.length > 0) {
      pills[0].classList.add('selected');
      pillContainer.dataset.selectedProteinId = pills[0].dataset.value || '';
    }

    pillContainer.dataset.hydrating = '0';
  });

  // No cart saves needed — "Paired with" on protein lines IS the state

});

//window.addEventListener('resize', loadHeaderSizes);

document.addEventListener('scroll', (event) => {
  if(!shippingBarSticky) return;

  if (lastScrollTop > window.scrollY) {
    shippingBarSticky.classList.add('shipping-bar-container-inner--fixed-with-header');
  }
  else {
    shippingBarSticky.classList.remove('shipping-bar-container-inner--fixed-with-header');
  }
  
  if (window.scrollY >= threshold) {
    shippingBarSticky.classList.add('shipping-bar-container-inner--fixed');
  }
  else {
    shippingBarSticky.classList.remove('shipping-bar-container-inner--fixed');
    shippingBarSticky.classList.remove('shipping-bar-container-inner--fixed-with-header');
  }
  
  lastScrollTop = window.scrollY;
});

// (Removed: setSaladProteinProperty, applyProteinPropertiesForSaladCard,
//  waitForCartLineByVariantId, and their event handlers.
//  Cart "Paired with" property on protein lines is now the single source of truth.)
